import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as serialSelectors, actions as serialActions } from 'ducks/inventoryEnquiry/stocking/serials';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { search } from 'api/inventoryEnquiry/stocking/serials';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { actions as formActions } from 'ducks/form';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
    gridName: 'IEStockingSerials',
    columnDefs: serialSelectors.columns(state),
    rowData: serialSelectors.data(state),
    appliedFilters: serialSelectors.filterRow(state) && filterSelectors.getFilters(state, serialSelectors.filterRow(state).formName),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: serialSelectors.gridOptions(state),
    isLoading: serialSelectors.isLoading(state),
    filterRow: serialSelectors.filterRow(state),
    selectedFilters: serialSelectors.selectedFilters(state),
    reqParams: (productSelectors.selected(state) || params.get('ProductId')) &&
      { ProductId: (productSelectors.selected(state) && productSelectors.selected(state).ProductId) || params.get('ProductId') },
    apiMethod: search

})

export const actions = {
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: serialActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
  applyFilters: filterActions.applyFilters
}
